import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_fav_n",
  "use": "icon-ic_fav_n-usage",
  "viewBox": "0 0 34 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 33\" id=\"icon-ic_fav_n\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1 0h32v32H1z\" /><path d=\"m16.772 26.981-7.58 3.986a2 2 0 0 1-2.903-2.108l1.448-8.442-6.133-5.978a2 2 0 0 1 1.108-3.412l8.476-1.231 3.79-7.68a2 2 0 0 1 3.588 0l3.79 7.68 8.476 1.231a2 2 0 0 1 1.108 3.412l-6.133 5.978 1.448 8.442a2 2 0 0 1-2.902 2.108l-7.58-3.986z\" stroke=\"#FF5159\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol